import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { ApiError, MessageService, DateUtilsHttpService } from '../../../../core';
import { ClienteFilter } from '../filter';
import { ClienteCadastroSituacaoChartComponent, ClienteSegmentoChartComponent } from '../charts';

@Component({
    selector: 'sgt-cliente-dashboard',
    templateUrl: './cliente-dashboard.component.html',
    styleUrls: ['./cliente-dashboard.component.less']
})
export class ClienteDashboardComponent {
    @Input() filter: ClienteFilter;

    @ViewChild('cadastroSituacaoChart') cadastroSituacaoChart: ClienteCadastroSituacaoChartComponent;
    @ViewChild('segmentoChart') segmentoChart: ClienteSegmentoChartComponent;

    constructor(private messageService: MessageService,
                private dateUtilsHttpService: DateUtilsHttpService) { }


    load() {
        // Cadastro Situação
        this.cadastroSituacaoChart.load(this.filter);
        // Segmentos
        this.segmentoChart.load(this.filter);
    }
}
